import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import attendantReadAction from './attendantRead.action.json' with { type: 'json' }

const attendantReadDefinition = defineReadAutoAction(attendantReadAction, 'attendant')

export default attendantReadDefinition
